import { Image, ImageSourcePropType, Pressable, StyleSheet, Text, View } from 'react-native';
import colors from '../theme';

interface BookCardProps {
  title: string;
  author: string;
  imageSource: ImageSourcePropType;
  progress?: number;
  onPress?: () => void;
}

export default function BookCard({ title, author, imageSource, progress, onPress }: BookCardProps) {
  return (
    <Pressable style={styles.container} onPress={onPress}>
      <Image source={imageSource} style={styles.cover} resizeMode="cover" />
      <Text style={styles.title} numberOfLines={3}>{title}</Text>
      <Text style={styles.author}>{author}</Text>
      {typeof progress === 'number' ? (
        <View style={styles.progressBar}>
          <View style={[styles.progressFill, { width: `${progress}%` }]} />
        </View>
      ) : null}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 140,
    marginRight: 16,
    backgroundColor: colors.panel,
    borderRadius: 18,
    overflow: 'hidden',
    shadowColor: '#39BFFF',
    shadowOpacity: 0.14,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 6 },
    elevation: 3,
  },
  cover: {
    width: '100%',
    height: 140,
    backgroundColor: colors.card,
    marginBottom: 10,
  },
  title: {
    color: colors.textPrimary,
    fontSize: 14,
    fontWeight: '800',
    lineHeight: 20,
    marginBottom: 4,
    paddingHorizontal: 8,
  },
  author: {
    color: colors.textSecondary,
    fontSize: 12,
    fontWeight: '700',
    marginBottom: 10,
    paddingHorizontal: 8,
  },
  progressBar: {
    height: 6,
    borderRadius: 99,
    backgroundColor: colors.card,
    overflow: 'hidden',
    marginHorizontal: 8,
    marginBottom: 8,
  },
  progressFill: {
    height: '100%',
    backgroundColor: colors.button,
  },
});
